import api from './api';

const register = (email, password) => api.post('/auth/register', { email, password });
const login = (email, password) => api.post('/auth/login', { email, password });
const getMe = () => api.get('/auth/me');

const authService = { register, login, getMe };
export default authService;
